/**
 * This file generated by generateIcons scripts
 * DO NOT EDIT DIRECTLY
 */

import React, { useEffect } from 'react';
import { IconSize } from '../interfaces';
import IconArrowLeftExtraSmall from './IconArrowLeftExtraSmall';
import IconArrowLeftLarge from './IconArrowLeftLarge';
import IconArrowLeftMedium from './IconArrowLeftMedium';
import IconArrowLeftSmall from './IconArrowLeftSmall';
import { jsx as ___EmotionJSX } from "@emotion/react";
const IconArrowLeft = _ref => {
  let {
    size = IconSize.Small,
    ...forwardedProps
  } = _ref;
  useEffect(() => {
    let iconSizeName = '';
    if (size === IconSize.ExtraSmall) iconSizeName = 'ExtraSmall';
    if (size === IconSize.Small) iconSizeName = 'Small';
    if (size === IconSize.Medium) iconSizeName = 'Medium';
    if (size === IconSize.Large) iconSizeName = 'Large';
    console.warn("Importing icons without size in the end is deprecated, and will not be supported in 5.x. Please use IconArrowLeft".concat(iconSizeName));
  }, [size]);
  if (size === IconSize.ExtraSmall) {
    return ___EmotionJSX(IconArrowLeftExtraSmall, forwardedProps);
  }
  if (size === IconSize.Small) {
    return ___EmotionJSX(IconArrowLeftSmall, forwardedProps);
  }
  if (size === IconSize.Medium) {
    return ___EmotionJSX(IconArrowLeftMedium, forwardedProps);
  }
  if (size === IconSize.Large) {
    return ___EmotionJSX(IconArrowLeftLarge, forwardedProps);
  }
  return null;
};
IconArrowLeft.displayName = 'IconArrowLeft';
export default IconArrowLeft;